import { render, staticRenderFns } from "./RealAccount.vue?vue&type=template&id=46e4299c&"
import script from "./RealAccount.vue?vue&type=script&lang=js&"
export * from "./RealAccount.vue?vue&type=script&lang=js&"
import style0 from "./RealAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports